module.exports = __webpack_public_path__ + "static/media/icon-clients-data-export.8812670e.svg";